<form [formGroup]="loginForm" (ngSubmit)="sendVerifyOtp()">
  <ion-input
    class="space-input"
    type="email"
    formControlName="username"
    [label]="passwordLoginContent[0]"
    required
    label-placement="floating"
    fill="outline"
    [placeholder]="passwordLoginContent[1]"
  ></ion-input>
  <div
    *ngIf="
      loginForm.get('username')?.invalid &&
      (loginForm.get('username')?.touched || loginForm.get('username')?.dirty)
    "
    class="error-head"
  >
    <small
      class="error-message"
      *ngIf="loginForm.get('username')?.errors?.['required']"
      >{{passwordLoginContent[2]}}</small
    >
    <small
      class="error-message"
      *ngIf="loginForm.get('username')?.errors && !loginForm.get('username')?.errors?.['required']"
        >{{passwordLoginContent[3]}}</small
    >
  </div>

  <ion-input
    class="space-input"
    type="password"
    formControlName="password"
    required
    label-placement="floating"
    fill="outline"
    [placeholder]="passwordLoginContent[4]"
    [label]="passwordLoginContent[5]"
  ></ion-input>
  <div
    *ngIf="
      loginForm.get('password')?.invalid &&
      (loginForm.get('password')?.touched || loginForm.get('password')?.dirty)
    "
    class="error-head"
  >
    <small
      class="error-message"
      *ngIf="loginForm.get('password')?.errors?.['required']"
      >{{passwordLoginContent[6]}}</small
    >
    <small
      class="error-message"
      *ngIf="loginForm.get('password')?.errors?.['minlength']"
      >{{passwordLoginContent[7]}}</small
    >
  </div>

  <ion-button
    expand="full"
    type="submit"
    class="login-button"
    [disabled]="loginForm.invalid"
    >{{passwordLoginContent[8]}}</ion-button
  >
</form>
